import stringToUrl from './string_to_url';

export default function (link = '', query, removeParams = []) {
    if (!query) {
        return link.toString();
    }
    const url = stringToUrl(link);
    const items = query.entries();
    let item = items.next();
    while (!item.done) {
        const [key, value] = item.value;
        if (removeParams.indexOf(key) < 0) {
            url.searchParams.append(key, value);
        }
        item = items.next();
    }
    return url.toString(url);
}



// WEBPACK FOOTER //
// ./static-source/js/lib/utils/get_url_without_params.js